import {
  alfredIntegrations,
  ConnectorConnectBody,
  ConnectorConnectResponse,
  ConnectorsResponse,
  ConnectorToolsResponse,
  GoogleConnectBody,
  GoogleConnectResponse,
  IntegrationsStatusResponse,
  MicrosoftConnectBody,
  MicrosoftConnectedConvosResponse,
  MicrosoftConnectResponse,
  MicrosoftItemLinkParams,
  MicrosoftItemResponse,
  MicrosoftService,
  NotionConnectBody,
  NotionConnectResponse,
  RotateConnectorKeyBody,
  RotateConnectorKeyResponse,
} from '@api/api/alfred-integrations';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';

export const postMicrosoftConnect = (body: MicrosoftConnectBody) => {
  const { path, schema } = alfredIntegrations.microsoftConnect;
  return apiFetch<MicrosoftConnectResponse>(path, {
    method: 'post',
    body,
    schema,
  });
};

export const deleteMicrosoftDisconnect = (service: MicrosoftService) => {
  const { path } = alfredIntegrations.microsoftDisconnect;
  const params = new URLSearchParams({ service });
  return apiFetch(`${path}?${params}`, { method: 'delete' });
};

export const postNotionConnect = (body: NotionConnectBody) => {
  const { path, schema } = alfredIntegrations.notionConnect;
  return apiFetch<NotionConnectResponse>(path, {
    method: 'post',
    body,
    schema,
  });
};

export const deleteNotionDisconnect = () => {
  const { path } = alfredIntegrations.notionDisconnect;
  return apiFetch(path, { method: 'delete' });
};

export const postGoogleConnect = (body: GoogleConnectBody) => {
  const { path, schema } = alfredIntegrations.googleConnect;
  return apiFetch<GoogleConnectResponse>(path, {
    method: 'post',
    body,
    schema,
  });
};

export const deleteGoogleDisconnect = (service: string) => {
  const { path } = alfredIntegrations.googleDisconnect;
  const params = new URLSearchParams({ service });
  return apiFetch(`${path}?${params}`, { method: 'delete' });
};

export const getServices = () => {
  const { path, schema } = alfredIntegrations.integrationsStatus;
  return apiFetch<IntegrationsStatusResponse>(path, { schema });
};

export const getConnectedConversations = (
  provider: string,
  service: string
) => {
  const { path, schema } = alfredIntegrations.connectedConversations;
  return apiFetch<MicrosoftConnectedConvosResponse>(path(provider, service), {
    schema,
  });
};

export const getMicrosoftItemLink = ({
  service,
  itemId,
  conversationId,
}: MicrosoftItemLinkParams) => {
  const { path, schema } = alfredIntegrations.microsoftItemLink;
  return apiFetch<MicrosoftItemResponse>(
    path({ service, itemId, conversationId }),
    { schema }
  );
};

export const getConnectors = () => {
  const { path, schema } = alfredIntegrations.connectors;
  return apiFetch<ConnectorsResponse>(path, { schema });
};

export const postConnectorConnect = (body: ConnectorConnectBody) => {
  const { path, schema } = alfredIntegrations.connectorConnect;
  return apiFetch<ConnectorConnectResponse>(path, {
    method: 'post',
    body,
    schema,
  });
};

export const deleteByoConnector = (connectorId: string) => {
  const { path } = alfredIntegrations.connectorDisconnect;
  return apiFetch(path(connectorId), { method: 'delete' });
};

export const putConnectorRotateKey = (
  connectorId: string,
  body: RotateConnectorKeyBody
) => {
  const { path, schema } = alfredIntegrations.connectorRotateKey;
  return apiFetch<RotateConnectorKeyResponse>(path(connectorId), {
    method: 'put',
    body,
    schema,
  });
};

export const getConnectorTools = (connectorId: string) => {
  const { path, schema } = alfredIntegrations.connectorTools;
  return apiFetch<ConnectorToolsResponse>(path(connectorId), { schema });
};
